(() => {
    if (!customElements.get("toggle-slide")) {
        class ToggleSlide extends HTMLElement {
            constructor() {
                super();
                this.init()
            }
            init() {
                this.toggle = this.querySelector("[toggle]");
                this.heading = this.querySelector("[heading]");
                this.subHeading = this.querySelector("[sub-heading]");
                this.beforeText = this.querySelector("[before-text]");
                this.afterText = this.querySelector("[after-text]");
                this.imageOff = this.querySelector("[image-off]");
                this.imageOn = this.querySelector("[image-on]");
                this.toggle.addEventListener("change", (() => {
                    if (this.toggle.checked) {
                        this.heading.classList.add("checked");
                        this.subHeading?.classList.add("checked");
                        this.beforeText.classList.add("checked");
                        this.afterText.classList.add("checked");
                        this.imageOff.classList.add("inactive");
                        this.imageOn.classList.remove("inactive")
                    } else {
                        this.heading.classList.remove("checked");
                        this.subHeading?.classList.remove("checked");
                        this.beforeText.classList.remove("checked");
                        this.afterText.classList.remove("checked");
                        this.imageOff.classList.remove("inactive");
                        this.imageOn.classList.add("inactive")
                    }
                }))
            }
        }
        customElements.define("toggle-slide", ToggleSlide)
    }
})();
//# sourceMappingURL=toggle-slide.js.map